import React from "react";



const Thomas = () => {
    return (
        <div className="Testimony">
            <img src="/images/image-thomas.jpg" alt="Thomas" />
            <section className="quotes">
                <p>Sunnyside's enthusiam coupled with their keen interest in our brand's success made it a satisfying and enjoyable experience</p>
                <section className="name-title">
                    <span>Thomas S.</span>
                    <span>Chief Operating Officer</span>
                </section>
            </section>
        </div>
    );
}

export default Thomas